module.exports = __webpack_public_path__ + "img/Leap Learning Lab Training Guide Kenya Sept 2018  - FRENCH.fbdcfb55.png";